<static-hdr></static-hdr>

<section class="container my-10"> <!-- Main Container -->

    <!-- Top Section: Breadcrumbs and Title -->
    <div class="row mb-3">
        <div class="col-12 d-flex justify-content-between align-items-center">

            <!-- Title -->
            <h1 class="font-weight-bold text-dark display-4">
                {{ categoryName }}
            </h1>

            <!-- Breadcrumbs -->
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent px-0 mb-0">
                    <li class="breadcrumb-item"><a [routerLink]="['/home']" class="text-muted">
                            المركز السعودي لكفائة الطاقة
                        </a>
                    </li>
                    <li class="breadcrumb-item"><a href="javascript:;" class="text-muted">المركز الإعلامي</a></li>
                    <li class="breadcrumb-item active text-primary font-weight-bold" aria-current="page">{{ categoryName
                        }}</li>
                </ol>
            </nav>
        </div>
    </div>

    <!-- Category Label Tag -->
    <!-- <div class="row mb-4">
        <div class="col-12">
            <span class="category-label-tag" [ngClass]="{
                    'cat-news':    category === CAT_NEWS,
                    'cat-events':  category === CAT_EVENTS,
                    'cat-library': category === CAT_LIBRARY
                  }">
                <i class="fa mr-2" [ngClass]="{
                     'fa-newspaper-o': category === CAT_NEWS,
                     'fa-calendar':    category === CAT_EVENTS,
                     'fa-photo':       category === CAT_LIBRARY
                   }"></i>
                {{ categoryName }}
            </span>
        </div>
    </div> -->

    <!-- Content Section -->
    <div class="row">
        <div class="col-12">

            <!-- Section Header: 'All News' + Search -->
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <!-- <h2 class="font-weight-bold display-5">جميع {{ categoryName }}</h2> -->

                <div class="search-box mt-3 mt-md-0" style="min-width: 300px;">
                    <div class="input-group search--btn">
                        <input type="text" class="form-control" [class.is-invalid]="searchError"
                            placeholder="بحث في العنوان أو الوصف..." [(ngModel)]="filterText" (keyup.enter)="onSearch()"
                            (ngModelChange)="onFilterChange()">
                        <span class="input-group-text" style="cursor:pointer;" (click)="onSearch()">
                            <i class="fa fa-search text-muted"></i>
                        </span>
                        <span *ngIf="filterText" class="input-group-text bg-white border-right-0"
                            style="cursor:pointer; border-left:none;" (click)="clearSearch()" title="مسح البحث">
                            <i class="fa fa-times text-muted"></i>
                        </span>
                    </div>
                    <small *ngIf="searchError" class="text-danger d-block mt-1">
                        <i class="fa fa-exclamation-circle ml-1"></i>
                        من فضلك أدخل 3 أحرف على الأقل
                    </small>
                </div>
            </div>
            <div class="mb-4"></div>


            <!-- ===== News / Events Grid ===== -->
            <div class="row" [busyIf]="loading" *ngIf="category !== CAT_LIBRARY">
                <div class="col-md-3 mb-4" *ngFor="let item of mediaCenters">
                    <div class="card h-100 shadow-sm border-0 rounded-lg overflow-hidden card-hover"
                        [ngClass]="{'card-featured': item.mediaCenter.isFeatured}"
                        style="display:flex; flex-direction:column;">
                        <!-- Image Container -->
                        <div class="card-img-top position-relative d-flex align-items-center justify-content-center bg-light"
                            style="height: 180px;">
                            <img [src]="getImage(item)" class="img-fluid card--image"
                                style="max-height: 100%; max-width: 100%; object-fit: cover;object-position: top;"
                                alt="{{ item.mediaCenter.title }}">
                            <!-- Featured Badge -->
                            <!-- <span *ngIf="item.mediaCenter.isFeatured" class="featured-badge">
                                <i class="fa fa-star"></i> مميز
                            </span> -->
                        </div>
                        <!-- Card Body -->
                        <div class="card-body" style="flex:1;">
                            <h6 class="card-title font-weight-bold mb-2 text-dark"
                                style="line-height: 1.5; min-height: 2.5em;">
                                {{ item.mediaCenter.title | slice:0:60 }}{{ item.mediaCenter.title.length > 60 ? '...' :
                                '' }}
                            </h6>
                            <p>{{ item.mediaCenter.summery | slice:0:60 }}{{ item.mediaCenter.summery?.length > 60 ?
                                '...' : '' }}</p>
                            <small class="text-muted d-block mb-2">{{ item.mediaCenter.date | luxonFormat:'yyyy-MM-dd'
                                }}</small>
                        </div>
                        <!-- View Details Button -->
                        <div class="card-footer border-0 pt-0 pb-3 px-3"
                            [ngClass]="item.mediaCenter.isFeatured ? 'bg-featured-footer' : 'bg-white'">
                            <a [routerLink]="['/media-center', 'view', item.mediaCenter.id]"
                                class="btn btn-block btn-sm font-weight-bold"
                                [ngClass]="item.mediaCenter.isFeatured ? 'btn-featured' : 'btn-outline-primary'"
                                style="border-radius: 8px; transition: all 0.25s ease;">
                                <i class="fa fa-eye ml-1"></i>
                                عرض التفاصيل
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-12" *ngIf="mediaCenters?.length === 0 && !loading">
                    <div class="alert alert-light text-center">
                        لا توجد نتائج مطابقة
                    </div>
                </div>
            </div>

            <!-- ===== Media Library Gallery Grid ===== -->
            <div class="row" [busyIf]="loading" *ngIf="category === CAT_LIBRARY">
                <div class="col-md-3 col-sm-6 mb-4" *ngFor="let item of mediaCenters; let i = index">
                    <div class="gallery-card card h-100 shadow-sm border-0 rounded-lg overflow-hidden card-hover"
                        [ngClass]="{'card-featured': item.mediaCenter.isFeatured}" (click)="openGallery(i)"
                        style="cursor: pointer;">

                        <!-- Thumbnail -->
                        <div class="gallery-thumb position-relative d-flex align-items-center justify-content-center bg-light"
                            style="height: 200px; overflow: hidden;">

                            <!-- Image thumbnail -->
                            <img *ngIf="!isVideo(item)" [src]="getImage(item)" class="img-fluid w-100 h-100"
                                style="object-fit: cover; transition: transform 0.3s ease;"
                                alt="{{ item.mediaCenter.title }}">

                            <!-- Video thumbnail: show poster image if available, else dark bg with play icon -->
                            <ng-container *ngIf="isVideo(item)">
                                <img *ngIf="item.imageAttachmentUrls" [src]="item.imageAttachmentUrls"
                                    class="img-fluid w-100 h-100"
                                    style="object-fit: cover; transition: transform 0.3s ease;"
                                    alt="{{ item.mediaCenter.title }}">
                                <div *ngIf="!item.imageAttachmentUrls"
                                    class="w-100 h-100 d-flex align-items-center justify-content-center"
                                    style="background:#1a1a2e;">
                                    <i class="fa fa-film text-white" style="font-size: 3rem; opacity:0.5;"></i>
                                </div>
                                <!-- Video badge -->
                                <span class="badge badge-dark"
                                    style="position:absolute;top:10px;right:10px;font-size:0.75rem;padding:4px 8px;border-radius:6px;">
                                    <i class="fa fa-video-camera mr-1"></i> فيديو
                                </span>
                            </ng-container>

                            <!-- Featured Badge (for non-video items, or alongside video badge) -->
                            <span *ngIf="item.mediaCenter.isFeatured && !isVideo(item)" class="featured-badge">
                                <i class="fa fa-star"></i> مميز
                            </span>
                            <span *ngIf="item.mediaCenter.isFeatured && isVideo(item)" class="featured-badge"
                                style="top: 40px;">
                                <i class="fa fa-star"></i> مميز
                            </span>

                            <!-- Hover overlay -->
                            <div class="gallery-overlay position-absolute d-flex flex-column align-items-center justify-content-center"
                                style="top:0;left:0;right:0;bottom:0; background: rgba(0,0,0,0.5); opacity:0; transition: opacity 0.3s;">
                                <!-- Icon changes based on type -->
                                <i class="fa text-white" [ngClass]="isVideo(item) ? 'fa-play-circle' : 'fa-search-plus'"
                                    style="font-size: 2.5rem;"></i>
                                <span class="text-white mt-2 small font-weight-bold">
                                    {{ isVideo(item) ? 'عرض الفيديو' : 'عرض الصورة' }}
                                </span>
                            </div>
                        </div>

                        <!-- Caption -->
                        <div class="card-body py-2 px-3"
                            [ngClass]="item.mediaCenter.isFeatured ? 'bg-featured-footer' : ''">
                            <p class="mb-0 text-dark font-weight-bold small" style="line-height:1.4;">
                                {{ item.mediaCenter.title | slice:0:50 }}{{ item.mediaCenter.title.length > 50 ? '...' :
                                '' }}
                            </p>
                            <small class="text-muted">{{ item.mediaCenter.date | luxonFormat:'yyyy-MM-dd' }}</small>
                        </div>
                    </div>
                </div>

                <div class="col-12" *ngIf="mediaCenters?.length === 0 && !loading">
                    <div class="alert alert-light text-center">لا توجد نتائج مطابقة</div>
                </div>
            </div>

            <!-- Pagination -->
            <div class="mt-4">
                <p-paginator [rows]="maxResultCount" [totalRecords]="totalCount"
                    (onPageChange)="onPageChange($event)"></p-paginator>
            </div>

        </div>
    </div>

</section>

<!-- ===== Gallery Lightbox Popup ===== -->
<div class="gallery-lightbox-backdrop" *ngIf="galleryOpen" (click)="closeGallery()"
    style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background:rgba(0,0,0,0.88);display:flex;align-items:center;justify-content:center;">

    <!-- Modal Box -->
    <div class="gallery-lightbox-modal" (click)="$event.stopPropagation()"
        style="position:relative;background:#fff;border-radius:16px;max-width:860px;width:92vw;max-height:90vh;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.5);display:flex;flex-direction:column;">

        <!-- Close Button -->
        <button class="gallery-close-btn" (click)="closeGallery()"
            style="position:absolute;top:14px;right:14px;z-index:10;background:#fff;border:none;border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.2);cursor:pointer;">
            <i class="fa fa-times text-dark"></i>
        </button>

        <!-- Counter Badge -->
        <div
            style="position:absolute;top:14px;left:14px;z-index:10;background:rgba(0,0,0,0.55);color:#fff;border-radius:20px;padding:4px 14px;font-size:0.85rem;">
            {{ galleryIndex + 1 }} / {{ galleryItems.length }}
        </div>

        <!-- Media Area -->
        <div
            style="flex:1;display:flex;align-items:center;justify-content:center;background:#111;min-height:380px;max-height:65vh;overflow:hidden;">

            <!-- Show IMAGE if not a video -->
            <img *ngIf="!currentIsVideo" [src]="currentGalleryImage" alt="{{ currentGalleryItem?.mediaCenter?.title }}"
                style="max-width:100%;max-height:65vh;object-fit:contain;display:block;">

            <!-- Show VIDEO if it's a video item -->
            <video *ngIf="currentIsVideo && currentGalleryVideo" [src]="currentGalleryVideo" controls autoplay
                style="max-width:100%;max-height:65vh;display:block;outline:none;" (click)="$event.stopPropagation()">
                متصفحك لا يدعم تشغيل الفيديو.
            </video>

            <!-- Fallback if video is still loading -->
            <div *ngIf="currentIsVideo && !currentGalleryVideo"
                class="d-flex flex-column align-items-center justify-content-center text-white"
                style="width:100%;height:380px;">
                <i class="fa fa-spinner fa-spin" style="font-size:2.5rem;"></i>
                <span class="mt-3 small">جاري تحميل الفيديو...</span>
            </div>
        </div>

        <!-- Caption -->
        <div style="padding:18px 24px;background:#fff;text-align:right;">
            <div class="d-flex align-items-center justify-content-start mb-1">
                <span *ngIf="currentIsVideo" class="badge badge-secondary ml-2" style="font-size:0.8rem;">
                    <i class="fa fa-video-camera mr-1"></i> فيديو
                </span>
                <h5 class="font-weight-bold mb-0 text-dark">{{ currentGalleryItem?.mediaCenter?.title }}</h5>
            </div>
            <small class="text-muted">{{ currentGalleryItem?.mediaCenter?.date | luxonFormat:'yyyy-MM-dd' }}</small>
            <p *ngIf="currentGalleryItem?.mediaCenter?.summery" class="text-muted small mt-1 mb-0">
                {{ currentGalleryItem?.mediaCenter?.summery }}
            </p>
        </div>

        <!-- Prev Arrow -->
        <button class="gallery-arrow gallery-arrow-prev" (click)="galleryPrev()"
            style="position:absolute;top:50%;left:14px;transform:translateY(-50%);background:rgba(255,255,255,0.9);border:none;border-radius:50%;width:44px;height:44px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,0.25);cursor:pointer;z-index:10;">
            <i class="fa fa-chevron-left text-dark"></i>
        </button>

        <!-- Next Arrow -->
        <button class="gallery-arrow gallery-arrow-next" (click)="galleryNext()"
            style="position:absolute;top:50%;right:14px;transform:translateY(-50%);background:rgba(255,255,255,0.9);border:none;border-radius:50%;width:44px;height:44px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,0.25);cursor:pointer;z-index:10;">
            <i class="fa fa-chevron-right text-dark"></i>
        </button>
    </div>
</div>

<!-- Gallery hover & animation styles -->
<style>
    /* ===== Category Label Tag ===== */
    .category-label-tag {
        display: inline-flex;
        align-items: center;
        padding: 6px 18px;
        border-radius: 30px;
        font-size: 0.95rem;
        font-weight: 700;
        letter-spacing: 0.02em;
    }

    .category-label-tag.cat-news {
        background-color: #e8f5ee;
        color: #1b8354;
        border: 1.5px solid #1b8354;
    }

    .category-label-tag.cat-events {
        background-color: #e8f0fb;
        color: #1a56db;
        border: 1.5px solid #1a56db;
    }

    .category-label-tag.cat-library {
        background-color: #f3e8fb;
        color: #7c3aed;
        border: 1.5px solid #7c3aed;
    }

    .card-hover {
        border: 2px solid transparent !important;
        transition: border-color 0.25s ease, box-shadow 0.25s ease;
    }

    .card-hover:hover {
        border-color: #1b8354 !important;
        box-shadow: 0 6px 24px #297d5949 !important;
    }

    /* ===== Featured Card Styles ===== */
    .card-featured {
        border: 2px solid #297D59 !important;
        background: linear-gradient(180deg, #fffbeb 0%, #ffffff 60%) !important;
    }

    .card-featured:hover {
        border-color: #297D59 !important;
        box-shadow: 0 6px 24px #297d5949 !important;
    }

    .featured-badge {
        position: absolute;
        top: 10px;
        right: 10px;
        background: linear-gradient(135deg, #297D59, #297D59);
        color: #fff;
        font-size: 0.72rem;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 20px;
        letter-spacing: 0.03em;
        box-shadow: 0 2px 8px #297d5949;
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .bg-featured-footer {
        background-color: #fff !important;
    }

    .btn-featured {
        background: linear-gradient(135deg, #297D59, #297D59);
        color: #fff;
        border: none;
    }

    .btn-featured:hover {
        background: linear-gradient(135deg, #297D59, #297D59);
        color: #fff;
    }

    .gallery-card:hover .gallery-overlay {
        opacity: 1 !important;
    }

    .gallery-card:hover .gallery-thumb img {
        transform: scale(1.07);
    }

    .gallery-lightbox-backdrop {
        animation: fadeInBackdrop 0.2s ease;
    }

    .gallery-lightbox-modal {
        animation: zoomInModal 0.22s ease;
    }

    @keyframes fadeInBackdrop {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes zoomInModal {
        from {
            transform: scale(0.88);
            opacity: 0;
        }

        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    .gallery-arrow:hover {
        background: #fff !important;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35) !important;
    }
</style>

<static-ftr></static-ftr>